import { useLang } from '@/i18n';
import EfIcon from '@elem/ui/ef-icon';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfSwiperOnlyH5 from '@elem/ui/ef-swiper-only-h5';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
// import EFXBoost from 'elem/ui-assets/icons/unregular/EFXBoost';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionA');
    const { locale = 'us' } = useRouter();
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);

    const imgAllA = {
        NA: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724571004129/a1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724571004650/b1.jpg',
        },
        EU: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725006976950/euPC1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725006976814/euH1.jpg',
        },
        UK: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725007587952/ukPC1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725007587543/ukH1.jpg',
        },
    };
    const imgLocaleA: any = {
        us: imgAllA.NA,
        ca: imgAllA.NA,
        uk: imgAllA.UK,
        eu: imgAllA.EU,
        de: imgAllA.EU,
        fr: imgAllA.EU,
        it: imgAllA.EU,
        es: imgAllA.EU,
    };
    const imgA = imgLocaleA[locale] || imgLocaleA['eu'];

    const imgAllB = {
        NA: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724817516851/X-boost-R3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724817516685/X-boost_R3%E6%88%B7%E5%A4%96.jpg',
        },
        EU: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725006977337/euPC2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725006977133/euH2.jpg',
        },
        UK: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725007587729/ukPC2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725007588134/ukH2.jpg',
        },
    };
    const imgLocaleB: any = {
        us: imgAllB.NA,
        ca: imgAllB.NA,
        uk: imgAllB.UK,
        eu: imgAllB.EU,
        de: imgAllB.EU,
        fr: imgAllB.EU,
        it: imgAllB.EU,
        es: imgAllB.EU,
    };
    const imgB = imgLocaleB[locale] || imgLocaleB['eu'];
    const items = [
        {
            pc: imgA.pc,
            h5: imgA.h5,
            section: (
                <>
                    <div className="icon">
                        <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1722864331577/c1.png" />
                    </div>
                    <div className="text">{t('a_title')}</div>
                </>
            ),
        },
        {
            pc: imgB.pc,
            h5: imgB.h5,
            section: (
                <>
                    <div className="icon">
                        <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1722864331577/c1.png" />
                    </div>
                    <div className="text">{t('b_title')}</div>
                </>
            ),
        },
    ];

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfSection hasAnimation={false} label={t('label')} title={t('title')} desc={t('desc')} />
            <EfSwiperOnlyH5 items={items} loop={true} />
            {IS_EU_SITES && <EfSpec className="spec-z" />}
        </div>
    );
}
